import {IDoc,IFile} from "@/models/files.interface";
import axios from "axios";
import {URL_API} from "@/config/utils";

export class FilesService{

  BASE_URL:string; 
  constructor(){
    this.BASE_URL=`${URL_API}`
  }
  async getAll(token:string,status:string="unattended"):Promise<IFile[]>{

    let list_files: IFile[] = [];   
    const config = {headers:{"Authorization": `Bearer ${token}`}}
    const resp=await axios.get(`${this.BASE_URL}uploaded-files?status_file=${status}`,config);
    let response= await resp.data;
    response.forEach(element=>{
      let docs_array:IDoc[]=[];
      element.docs.forEach(doc=>{
	const nDoc:IDoc ={name:doc.name,kind:doc.kind,real_location:doc.real_location};
	docs_array.push(nDoc);
      });
      const nFile:IFile={
	  status:element.status,
	  _id:element._id,
	  loaded_at:new Date(element.loaded_at),
	  enterprise:element.enterprise,
	  titulo:element.titulo,
	  aprovechamiento:element.aprovechamiento,
	  uploaded_by:element.uploaded_by, 
	  followed_by:element.followed_by,
	  docs:docs_array
      };

      list_files.push(nFile);
    });
    return list_files;
  }//fin de getAll

  async changeStatus(token:string,id:string,stat:string):Promise<Boolean>{
    
    const config = {headers:{"Authorization": `Bearer ${token}`}}
    const resp = await axios.post(`${this.BASE_URL}change-file-status/${id}?status_file=${stat}`,{},config);
    if (resp.status==202) return true;
      return false

  }//fin de changeStatus

  async uploadFiles(token:string,data:FormData){

    const config = {headers:{"Authorization": `Bearer ${token}`}}
    const resp = await axios.post(`${this.BASE_URL}upload-file`,data,config);
    const resp_estatus=await resp.status;
    if (resp_estatus==202) return true;
    return false;

  }
  downloadFile(token:string,id:string){
    const don=(`${this.BASE_URL}download-docs/${id}`);
    window.location.href=don;
  }

  downloadSmsFile(token:string,phone_number:string="all",status:string="unattended",ffinicio?:string,ffinal?:string){
    let query_params=(phone_number.trim()==""?`phone_number=all`:`phone_number=${phone_number}`);
     query_params+=(status.trim()==""?"":`&status_message=${status}`);
     query_params+=( ffinicio!="" && ffinicio!=null  && ffinal!="")?(`&finicio=${ffinicio}&ffinal=${ffinal}`):"";

    const don = `${this.BASE_URL}messages-phone-status-xls?${query_params}`;
    window.location.href=don;
  }

}//end of class
